"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pages = void 0;
var useComponentsContext_1 = require("@centered/components/dist/hooks/useComponentsContext");
var ArrowIcon_1 = __importDefault(require("@centered/components/dist/icons/ArrowIcon"));
var CenteredLogoWhite_1 = __importDefault(require("@centered/components/dist/icons/CenteredLogoWhite"));
var firebase_1 = require("@centered/firebase");
var faGoogle_1 = require("@fortawesome/free-brands-svg-icons/faGoogle");
var faWarning_1 = require("@fortawesome/pro-solid-svg-icons/faWarning");
var faSpinner_1 = require("@fortawesome/pro-solid-svg-icons/faSpinner");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = require("@xstate/react");
var react_2 = __importStar(require("react"));
var AuthInput_1 = __importDefault(require("./AuthInput"));
var AuthSubmitButton_1 = __importDefault(require("./AuthSubmitButton"));
var authMachine_1 = require("./authMachine");
exports.pages = [
    'login',
    'signup',
    'reset-password',
    'pick-password',
    'connect-desktop',
    'connect-chrome-extension',
    'account-connected',
    'chrome-extension-uninstall',
];
function AuthPage(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, initialPage = _a.initialPage, onPageChange = _a.onPageChange, onUserAuthenticated = _a.onUserAuthenticated, resetPasswordToken = _a.resetPasswordToken, onGoogleLogin = _a.onGoogleLogin, chromeExtensionId = _a.chromeExtensionId, initialAuthError = _a.authError, chromeExtensionUninstallUserId = _a.chromeExtensionUninstallUserId, isEmailOnly = _a.isEmailOnly, isLoggingIn = _a.isLoggingIn;
    var _c = (0, react_2.useState)(initialAuthError), authError = _c[0], setAuthError = _c[1];
    (0, react_2.useEffect)(function () {
        setAuthError(initialAuthError);
    }, [initialAuthError]);
    var _d = (0, react_1.useMachine)(authMachine_1.authMachine, {
        context: {
            resetPasswordToken: resetPasswordToken,
        },
    }), _e = _d[0], state = _e.value, context = _e.context, matches = _e.matches, send = _d[1];
    var _f = (0, react_2.useState)(''), email = _f[0], setEmail = _f[1];
    var _g = (0, react_2.useState)(''), password = _g[0], setPassword = _g[1];
    var _h = (0, react_2.useState)(''), name = _h[0], setName = _h[1];
    var isLogin = matches('Login');
    var isSignup = matches('Signup');
    var isResetPassword = matches('Reset Password');
    var isPickPassword = matches('Pick Password');
    var isConnectToDesktop = matches('Connect To Desktop App');
    var isConnectToChromeExtension = matches('Connect To Chrome Extension');
    var isAccountConnected = matches('Account Connected');
    var isChromeExtensionUninstall = matches('Chrome Extension Uninstall');
    (0, react_2.useEffect)(function () {
        switch (initialPage) {
            case 'login':
                if (!isLogin)
                    send('Go to Login');
                break;
            case 'signup':
                if (!isSignup)
                    send('Go to Signup');
                break;
            case 'reset-password':
                if (!isResetPassword)
                    send('Go to Reset Password');
                break;
            case 'pick-password':
                if (!isPickPassword)
                    send('Go to Pick Password');
                break;
            case 'connect-desktop':
                if (!isConnectToDesktop)
                    send('Go to Connect Desktop');
                break;
            case 'connect-chrome-extension':
                if (!isConnectToChromeExtension && chromeExtensionId) {
                    send({
                        type: 'Go to Connect Chrome Extension',
                        chromeExtensionId: chromeExtensionId,
                    });
                }
                break;
            case 'account-connected':
                if (!isAccountConnected)
                    send('Go to Account Connected');
                break;
            case 'chrome-extension-uninstall':
                if (!isChromeExtensionUninstall) {
                    send({
                        type: 'Go to Chrome Extension Uninstall',
                        chromeExtensionUninstallUserId: chromeExtensionUninstallUserId,
                    });
                }
                break;
            default:
                break;
        }
    }, [
        initialPage,
        chromeExtensionId,
        chromeExtensionUninstallUserId,
        isLogin,
        isSignup,
        isResetPassword,
        isPickPassword,
        isConnectToDesktop,
        isConnectToChromeExtension,
        isAccountConnected,
    ]);
    var _j = (0, react_2.useState)(), _currentPage = _j[0], setCurrentPage = _j[1];
    var getPage = function () {
        if (matches('Login'))
            return 'login';
        if (matches('Signup'))
            return 'signup';
        if (matches('Reset Password'))
            return 'reset-password';
        if (matches('Pick Password'))
            return 'pick-password';
        if (matches('Connect To Desktop App'))
            return 'connect-desktop';
        if (matches('Connect To Chrome Extension'))
            return 'connect-chrome-extension';
        if (matches('Account Connected'))
            return 'account-connected';
    };
    (0, react_2.useEffect)(function () {
        var page = getPage();
        if (page) {
            setCurrentPage(function (oldPage) {
                if (oldPage !== page) {
                    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page);
                    return page;
                }
                return oldPage;
            });
        }
    }, [state, onPageChange]);
    (0, react_2.useEffect)(function () {
        if (matches('Signup.Signup Complete') || matches('Login.Login Complete')) {
            onUserAuthenticated === null || onUserAuthenticated === void 0 ? void 0 : onUserAuthenticated();
        }
    }, [state, matches]);
    var onSubmit = function () {
        setAuthError(undefined);
        if (matches('Login')) {
            send({ type: 'Log In', email: email, password: password });
        }
        else if (matches('Signup')) {
            send({ type: 'Sign Up', email: email, password: password, name: name });
        }
        else if (matches('Reset Password')) {
            send({ type: 'Reset Password', email: email });
        }
        else if (matches('Pick Password')) {
            send({ type: 'Pick Password', password: password });
        }
        else if (matches('Connect To Desktop App')) {
            send('Connect Desktop');
        }
        else if (matches('Connect To Chrome Extension')) {
            send({
                type: 'Connect Extension',
                chromeExtensionId: chromeExtensionId !== null && chromeExtensionId !== void 0 ? chromeExtensionId : '',
            });
        }
        else if (matches('Account Connected')) {
            document.location.href = 'centered://';
        }
    };
    var isConnectionScreen = matches('Connect To Chrome Extension') || matches('Connect To Desktop App');
    var getHeaderText = function () {
        if (matches('Login'))
            return "OK, let's do this...";
        if (matches('Signup'))
            return 'Claim my free trial \nSukha membership';
        if (matches('Reset Password') || matches('Pick Password'))
            return 'Reset Password';
        if (matches('Chrome Extension Uninstall'))
            return 'Account Disconnected';
        if (matches('Account Connected'))
            return 'Account Connected';
        return '';
    };
    var getSubmitButtonText = function () {
        if (matches('Login'))
            return 'Continue' + (!isEmailOnly ? ' with Email' : '');
        if (matches('Signup'))
            return 'Create Account';
        if (matches('Reset Password.Reset Password Confirmation'))
            return '';
        if (matches('Reset Password'))
            return 'Email Instructions';
        if (matches('Pick Password'))
            return 'Reset Password';
        return '';
    };
    var getStateExplainerText = function () {
        if (matches('Pick Password.Pick Password Confirmation'))
            return 'Your password has been reset. Redirecting you to log in.';
        if (matches('Chrome Extension Uninstall'))
            return 'Your Chrome extension was uninstalled. We can no longer track your browser activity.';
        if (matches('Reset Password.Reset Password Confirmation'))
            return 'Please check your email for reset instructions.';
        if (matches('Account Connected'))
            return 'You can now return to Sukha.';
        return '';
    };
    return (react_2.default.createElement("div", { className: "w-full flex flex-col ".concat(!isConnectionScreen ? 'max-w-md' : 'justify-center', " ").concat(className ? className : '') },
        (matches('Login') || matches('Signup')) && !isEmailOnly && (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement("div", { className: "flex flex-col items-center justify-center" },
                react_2.default.createElement(SocialAuth, { onGoogleLogin: onGoogleLogin, loggingIn: isLoggingIn })),
            react_2.default.createElement("div", { className: "flex flex-col items-center justify-center my-4" },
                react_2.default.createElement("h4", { className: "text-1xl md:text-2xl font-bold whitespace-pre" }, "or")))),
        (matches('Reset Password') || matches('Pick Password')) && (react_2.default.createElement("div", { onClick: function () { return send('Go to Login'); }, className: "inline-flex items-center gap-2 arrow-button cursor-pointer mb-4" },
            react_2.default.createElement("div", { className: "arrow-icon--reversed" },
                react_2.default.createElement(ArrowIcon_1.default, { direction: "left" })),
            react_2.default.createElement("p", { className: "text-sm font-semibold" }, "Back to Login"))),
        isEmailOnly && (react_2.default.createElement("header", { className: "flex flex-col" },
            react_2.default.createElement("h1", { className: "text-3xl md:text-4xl font-bold mb-8 whitespace-pre" }, getHeaderText()))),
        react_2.default.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
                onSubmit();
            } },
            (matches('Login') ||
                matches('Signup') ||
                matches('Reset Password')) && (react_2.default.createElement("div", { className: "space-y-4" },
                react_2.default.createElement(AuthInput_1.default, { placeholder: "Email", type: "email", required: true, disabled: !matches('Login.Idle') &&
                        !matches('Signup.Idle') &&
                        !matches('Reset Password.Idle'), autoComplete: "email", onChange: function (e) { return setEmail(e.target.value); } }),
                (matches('Login') || matches('Signup')) && (react_2.default.createElement(AuthInput_1.default, { placeholder: "Password", type: "password", autoComplete: "current-password", onChange: function (e) {
                        setPassword(e.target.value);
                    }, disabled: !matches('Login.Idle') &&
                        !matches('Signup.Idle') &&
                        !matches('Pick Password.Idle'), required: true, adornment: context.error ? (react_2.default.createElement("div", { className: "font-semibold text-sm pr-2 cursor-pointer", onClick: function () {
                            setAuthError('');
                            send('Go to Reset Password');
                        } }, "Reset Password")) : undefined })),
                matches('Signup') && (react_2.default.createElement(AuthInput_1.default, { className: "mb-3", value: name, disabled: !matches('Login.Idle') && !matches('Signup.Idle'), onChange: function (e) {
                        setName(e.target.value);
                    }, placeholder: "Name", autoComplete: "name", required: true, autoFocus: initialPage !== 'signup' })))),
            matches('Pick Password') && (react_2.default.createElement(AuthInput_1.default, { title: "New Password", type: "password", required: true, placeholder: "New Password", value: password, autoComplete: "new-password", onChange: function (e) {
                    setPassword(e.target.value);
                } })),
            (matches('Login') ||
                matches('Signup') ||
                matches('Reset Password') ||
                matches('Pick Password')) && (react_2.default.createElement(react_2.default.Fragment, null,
                (context.error || authError) && (react_2.default.createElement("div", { className: "text-white md:mt-5 mb-5 flex-1 md:flex-auto flex flex-col items-center justify-center" },
                    react_2.default.createElement("h2", { className: "text-center" },
                        react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faWarning_1.faWarning })),
                    react_2.default.createElement("p", { className: "text-sm text-center" }, context.error || authError))),
                react_2.default.createElement("footer", { className: "flex items-center justify-center mt-4 gap-8 ".concat(!isEmailOnly && (matches('Login') || matches('Signup'))
                        ? ''
                        : ' md:justify-between') },
                    isEmailOnly && (matches('Login') || matches('Signup')) ? (react_2.default.createElement("div", { className: "hidden md:block" },
                        react_2.default.createElement(TermsDisclaimer, null))) : !isEmailOnly &&
                        (matches('Login') || matches('Signup')) ? undefined : (react_2.default.createElement("div", { className: "flex-1" })),
                    react_2.default.createElement(AuthSubmitButton_1.default, { onClick: onSubmit, disabled: !matches('Login.Idle') &&
                            !matches('Signup.Idle') &&
                            !matches('Reset Password.Idle') &&
                            !matches('Connect To Desktop App.Idle') &&
                            !matches('Connect To Chrome Extension.Idle') &&
                            !matches('Pick Password.Idle') &&
                            !matches('Account Connected') }, getSubmitButtonText())),
                !isEmailOnly && (matches('Login') || matches('Signup')) ? (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement("hr", { className: "border-gray-600 w-full mt-5 mb-5" }),
                    react_2.default.createElement(TermsDisclaimer, null))) : undefined))),
        getStateExplainerText() && react_2.default.createElement("p", null, getStateExplainerText()),
        (matches('Connect To Desktop App') ||
            matches('Connect To Chrome Extension')) && (react_2.default.createElement(ConnectApp, { app: matches('Connect To Desktop App') ? 'desktop' : 'chrome-extension', requestConnect: function () { return onSubmit(); }, loading: false }))));
}
exports.default = AuthPage;
function SocialAuth(_a) {
    var onGoogleLogin = _a.onGoogleLogin, loggingIn = _a.loggingIn;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("style", null, "\n          .button {\n            background: linear-gradient(95.64deg, #d2116b 0%, #e2341c 100%);\n          }\n\n          .button:hover {\n            background: #9f1a4b;\n          }\n        "),
        react_2.default.createElement("div", { onClick: onGoogleLogin, className: "button flex cursor-pointer text-white font-normal text-lg px-4 py-2 rounded-full gap-2 items-center linear-gradient(95.64deg, #d2116b 0%, #e2341c 100%) hover:bg-[#9f1a4b] transition-colors" },
            loggingIn ? (react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faSpinner_1.faSpinner, spin: true })) : (react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faGoogle_1.faGoogle })),
            react_2.default.createElement("p", { className: "whitespace-nowrap" }, "Continue with Google"))));
}
function ConnectApp(_a) {
    var app = _a.app, requestConnect = _a.requestConnect, loading = _a.loading;
    var _b = (0, firebase_1.useCurrentUser)(), currentUser = _b.currentUser, signOut = _b.signOut;
    (0, react_2.useEffect)(function () {
        if (!currentUser || loading)
            return;
        requestConnect();
    }, [currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, loading]);
    return (react_2.default.createElement("div", { className: "flex flex-col items-center mx-auto w-full justify-center" },
        react_2.default.createElement(CenteredLogoWhite_1.default, { className: "w-20 h-20 md:w-32 md:h-32" }),
        react_2.default.createElement("h1", { className: "text-2xl md:text-4xl text-center" },
            "Connect ",
            react_2.default.createElement("b", null, app === 'desktop' ? 'Sukha' : 'Chrome Extension')),
        react_2.default.createElement("div", { className: "w-full text-center mb-10" },
            react_2.default.createElement("p", null,
                "You're currently logged in as ",
                react_2.default.createElement("b", null, currentUser === null || currentUser === void 0 ? void 0 : currentUser.email)),
            react_2.default.createElement("div", { onClick: signOut, className: "underline my-4 text-sm cursor-pointer" }, "Switch Account")),
        react_2.default.createElement("div", { onClick: requestConnect, className: "px-6 py-4 cursor-pointer text-white border border-white border-opacity-50 rounded-md font-semibold backdrop-filter backdrop-blur ".concat(loading ? 'pointer-events-none opacity-50' : '') }, "Connect Desktop App")));
}
function TermsDisclaimer() {
    var Link = (0, useComponentsContext_1.useComponents)().Link;
    if (!Link) {
        return react_2.default.createElement(react_2.default.Fragment, null);
    }
    return (react_2.default.createElement("div", { className: "text-sm text-gray-300" },
        "You acknowledge that you read, and agree to our",
        ' ',
        react_2.default.createElement(Link, { href: "/terms", className: "font-bold" },
            react_2.default.createElement("b", null, "Terms of Service")),
        ' ',
        "and our",
        ' ',
        react_2.default.createElement(Link, { href: "/privacy", className: "font-bold" },
            react_2.default.createElement("b", null, "Privacy Policy")),
        "."));
}
